var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowForward = props => /*#__PURE__*/React.createElement("svg", _extends({
  "aria-label": "Arrow pointing to the right",
  xmlns: "http://www.w3.org/2000/svg",
  role: "img",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10.664 4l-1.41 1.41 5.58 5.59h-12.17v2h12.17l-5.58 5.59 1.41 1.41 8-8-8-8z"
})));
export { SvgArrowForward as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBhcmlhLWxhYmVsPSJBcnJvdyBwb2ludGluZyB0byB0aGUgcmlnaHQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiByb2xlPSJpbWciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxwYXRoIGQ9Ik0xMC42NjQgNGwtMS40MSAxLjQxIDUuNTggNS41OWgtMTIuMTd2MmgxMi4xN2wtNS41OCA1LjU5IDEuNDEgMS40MSA4LTgtOC04eiI+PC9wYXRoPgo8L3N2Zz4K";